import moment from 'moment';
import 'moment-timezone';

export class TimeZoneUtils {

    public static timezoneConvert(dt) {
        const d = new Date(dt);
        var timeZoneFromDB: any = localStorage.getItem('timezoneName');
        let timezone = moment.tz(d, timeZoneFromDB).format("YYYY-MM-DD HH:mm:ss");
        return timezone;

    }

    public static inverseTimezoneConvert(dt){
        var timeZoneFromDB: any = localStorage.getItem('timezoneName');
        const d =  moment.tz(dt, timeZoneFromDB);
        let timezone = d.local().format("YYYY-MM-DD HH:mm:ss");
        return timezone;
    }
}